<template>
  <div class="mw-panel mw-form-layout mw-process-manage">
    <div class="__buttons" v-show="showButton">
      <div style="display:inline-block;padding-left:2px;padding-top:2px;padding-right:12px;font-size: 14px;">
        <span v-if="curStatus==0">设计</span>
        <span v-else-if="curStatus==1">启用</span>
        <span v-else>历史</span>(<span v-text="curVersion"></span>.0)
      </div>
    </div>

    <mw-dialog title="新建表单项" size="mini_mini" :appendToBody="true" ref="editFormDialog" :footerButton="editFormFooterButton">
      <el-form :model="form" style="margin-top: 20px;" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-col :span="24" v-if="addFormItemFlag">
          <el-form-item label="关联表单">
            <el-input v-model="relateFormName" style="width:60%" :disabled="true"></el-input>
            <el-button @click="relateSelectForm">选择</el-button>
          </el-form-item>
          <el-form-item label="关联表单" v-show="false">
            <el-input v-model="form.id" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </mw-dialog>

    <mw-dialog title="表单管理" size="small_large" :appendToBody="true" ref="formDialog" :footerButton="footerFormButton">
      <ul class="process-list">
        <li v-for="(item,index) in formList"
            :key="index"
            @click="selectForm(item.id)"
            @dblclick="editSelectForm(item.id)"
            :class="{list_bg:(item.id!=selKey),active:(item.id==selKey)}">
          <span v-text="item.name"></span>
        </li>
      </ul>
    </mw-dialog>

    <mw-dialog title="表单版本管理" size="small_large" :appendToBody="true" ref="versionDialog" :footerButton="footerButton">
      <ul class="process-list">
        <li v-for="(item,index) in versionList"
            :key="index"
            @click="selectVersion(item.version,item.status,item.id)"
            @dblclick="editVersion"
            :class="{list_bg:(item.version!=selVersion),active:(item.version==selVersion)}">
          <span v-text="item.name"></span>(<span v-text="item.version"></span>.0)
          <span v-if="item.status==0" class="pull-right">设计</span>
          <span v-else-if="item.status==1" class="pull-right">启用</span>
          <span v-else class="pull-right">历史</span>
        </li>
      </ul>
    </mw-dialog>


    <mw-dialog title="管理回收站" size="small_large" :appendToBody="true" ref="recycleBinDialog"
               :footerButton="recycleBinFooterButton">
      <ul class="process-list">
        <li v-for="(item,index) in versionDelList"
            :key="index"
            @click="selectDelVersion(item.version,item.status,item.id)"
            :class="{list_bg:(item.version!=selDelVersion),active:(item.version==selDelVersion)}">
          <span v-text="item.name"></span>(<span v-text="item.version"></span>.0)
        </li>
      </ul>
    </mw-dialog>
    <mw-dialog title="修改记录" width="900" height="600" ref="revisionDialog">
      <componentRevision :componentId="formId" ref="revisionComp" @revert="formRevert"></componentRevision>
    </mw-dialog>
    <div class="mw-form_id mw-panel">
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Vue from 'vue';
  import componentRevision from '../../componentRevision'
  import util from '@/common/util.js'
  import formExpContext from '@/common/components/extend/form/src/formExpContext'
  export default {
    name:"mw-form-edit",
    components:{
      componentRevision
    },
    props:{
      propAppId:String,
      propSysId:String,
      propModuleId:String
    },
    data() {
      let appId=this.propAppId || this.$route.params.appId;
      let sysId=this.propSysId || this.$route.params.sysId;
      let moduleId=this.propModuleId || this.$route.params.moduleId;
      return {
        formList:[],
        form:{
          name:'',
          id:''
        },
        relateFormName:'',
        selKey:'',
        addFormItemFlag:false,
        versionNumber:1,

        showButton: false,
        appId: appId,
        sysId:sysId,
        moduleId: moduleId,
        formId: '',
        key:'',
        isRelation:false,
        $newForm: undefined,
        formData: {},

        editFormFooterButton:[
          {
            label: '取消',
            func: this.editFormCancel
          },
          {
            label: '保存',
            func: this.editFormSave
          }
        ],

        footerFormButton:[
          {
            label: '关闭',
            func: this.closeFormDialog
          },
          {
            label: '删除',
            func: this.deleteFormItem
          },
          {
            label: '上移',
            func: this.upFormItem
          },
          {
            label: '下移',
            func: this.downFormItem
          },
          {
            label: '新建表单项',
            func: this.addFormItem
          },
          {
            label: '编辑表单项',
            func: this.editFormItem
          },
          {
            label: '编辑表单',
            func: this.editForm
          }
        ],

        footerButton: [{
          label: '添加新版本',
          func: this.addNewVersion
        },{
          label: '编辑',
          func: this.editVersion
        }, {
          label: '启用',
          func: this.enableVersion
        }, {
          label: '删除',
          func: this.deleteVersion
        }, {
          label: '回收站',
          func: this.recycleBinManager
        }],

        recycleBinFooterButton: [
          {
            label: '恢复',
            func: this.recoverVersion
          },
          {
            label: '彻底删除',
            func: this.cascadeDeleteVersion
          }, {
            label: '返回',
            func: this.returnVersionManager
          }
        ],
        versionList: [],
        versionDelList: [],

        selDelVersionId: 0,
        selDelVersion: 0,
        selDelStatus: 0,

        curVersionId:'',
        curVersion: 0,//当前显示的版本
        curStatus: 0,//当前状态

        selVersionId:'',
        selVersion: 0,
        selStatus: 0,

        editable: false,

        /**
         * @author huang
         * @type {{fldWhSerialNumber: string, fldWhYear: string, fldWhFileWordId:string,fldWhFildWordName:string}}
         * @desc 文号控件输出数据保存到表单数据里, 流水号、年度、文件字控件本身可固定域名。
         */
        extraFormField: {}
      };
    },
    computed: {
      ...mapGetters([
        'expUser',
        'initInfo'
      ])
    },
    mounted() {
      this.loadForm();
    },
    methods: {

      selectForm(id){
        let me = this;
        this.selKey=id;
      },

      editSelectForm(id){
        let me=this;
        me.key=id;
        me.selKey=id;
        me.editForm();
      },

      editFormCancel(){
        this.mwRef('editFormDialog').hide();
      },

      editFormSave(){
        let me=this;
        let data={};
        data.name=me.form.name;
        if(!data.name){
          this.mwMsg('warning',"名称不能为空")
          return;
        }
        if(me.addFormItemFlag){
          data.id=me.form.id;
        }else{
          data.key=me.form.id;
        }
        PF.ajax("api/app/createFormItem",data,me.moduleId,me.appId).then((data) => {
          if(me.key!=data.result.key){
            me.key=data.result.key;
            me.selKey=me.key;
            me.loadForm();
          }
          me.isDirty=false;
          me._refreshFormList();
          this.mwRef('editFormDialog').hide();
        });
      },
      upFormItem(){
        let me=this;
        if(me.formList.length==0){
          return;
        }
        PF.ajax("api/app/upModuleFormItem",{key:me.selKey},me.moduleId,me.appId).then((data) => {
          me._refreshFormList()
        });
      },
      downFormItem(){
        let me=this;
        if(me.formList.length==0){
          return;
        }
        PF.ajax("api/app/downModuleFormItem",{key:me.selKey},me.moduleId,me.appId).then((data) => {
          me._refreshFormList()
        });
      },
      deleteFormItem(){
        let me=this;
        me.mwConfirm('您确定要删除此关联表单项吗').then(() => {
          PF.ajax("api/app/deleteModuleFormItem",{key:me.selKey},me.moduleId,me.appId).then((data) => {
            if(me.key==me.selKey){
              me.key=data.result.key;
              me.selKey=me.key;
              this.loadForm();
            }
            me._refreshFormList();
          });
        }).catch(() => {

        });

      },
      closeFormDialog(){
        this.mwRef('formDialog').hide();
      },
      //新建表单
      addFormItem(){
        let me=this;
        me.addFormItemFlag=true;
        me.form.name="";
        me.form.id="";
        me.relateFormName="";

        me.mwRef('editFormDialog').show();
      },
      editFormItem(){
        let me=this;
        me.addFormItemFlag=false;
        me.form.name='';
        me.formList.forEach(v=>{
          if(v.id==me.selKey){
            me.form.name=v.name;
            me.form.id=me.selKey;
          }
        })

        me.mwRef('editFormDialog').show();
      },
      //编辑表单
      editForm(){
        this.mwRef('formDialog').hide();
        this.key=this.selKey;
        this.loadForm();
      },
      _refreshFormList(){
        var me=this;
        PF.ajax("api/app/listModuleForm",{moduleId:me.moduleId,appId:me.appId}).then((data) => {
          me.formList=data.result;
        });
      },
      //管理表单
      formManage(){
        let me=this;
        this.selKey=this.key;
        me._refreshFormList();
        me.mwRef('formDialog').show();
      },

      //设计按钮
      showDesign(){
        this.$newForm.showDesign(true)
      },
      //脚本
      showJsEditor(){
        this.$newForm.showJsEditor(true)
      },
      //预览
      preview(){

        let data=this.getDefinitionData();
        this.lintScript(data.script).then(result => {
          if(!result)return;
          this.$newForm.preview()
        });
      },
      lintScript(script) {
        if(!script) return Promise.resolve(true);
        return util.esLintMsg(script,{title:"语法错误，注意不要用es6语法"}).then(result=>{
          return result;
        })
      },
      getDefinitionData() {
        let me=this;
        let designerTabBtn=$(me.$el).find(".x-fd-cmd-design");
        let isDesignerNotActive=!designerTabBtn.is(".active")
        if (isDesignerNotActive) {
          //当前不是在设计界面的话，先切换回去再取值，否则隐藏的html一些取调试之类的会取不到。
          designerTabBtn.click();
        }
        let data=me.$newForm.getDefinitionData();
        if (isDesignerNotActive) {
          $(me.$el).find(".x-fd-cmd-js").click();
        }
        return data;
      },
      //保存
      save(flag){
        let me=this;
        let data=me.getDefinitionData();
        let publishForm=(flag==undefined?false:flag);
        /*if(!data.code){
          me.mwMsg('warning','请输入表单属性【分类】')
          return false
        }*/
        if(!data.name){
          me.mwMsg('warning','请输入表单属性【名称】')
          return false
        }
        me.lintScript(data.script).then(result => {
          if(!result)return;
          let sp = {
            publishForm:publishForm,
            name: data.name,
            code: data.code,
            content: data,
            customId: data.customId,
            owner:me.sysId,
            "#versionNumber":me.versionNumber,
            "#sync":true
          };
          function walkItems(items,fn){
            for (var  i = 0; i < items.length; i++) {
              const it = items[i];
              if(!fn(it)){
                return false;
              }
              if(it.items){
                let f=walkItems(it.items,fn);
                if(!f)return false;
              }
            }
            return true;
          }
          let isInputValid=walkItems(data.items,it=>{
            if(_.isFunction(it.isFormField) && it.isFormField() && !it.name){
              PF.message("warning","请填写域名.");
              setTimeout(()=>{
                $(me.$el).find("[wid='"+it.id+"']").mousedown();
              },500)
              return false;
            }else{
              return true;
            }
          });
          if(!isInputValid) return;
          me.mwApi.app.saveModuleForm(sp, me.formId, me.moduleId, me.key,me.curVersion,me.appId).then((res) => {
            me.$store.dispatch('setAppTreeItemName', {id: me.moduleId, name:data.name});
            me.versionNumber= res.result['#versionNumber'] || 1;
            if(publishForm){
              me.mwMsg('发布成功');
              me.curStatus=1;
              $(me.$el.querySelector('.x-fd-cmd-save-enable')).hide();
            }else{
              me.mwMsg('保存成功');
            }
            me.isDirty=false;
          });
        });
      },

      //创建新表单
      createNewForm() {
        let me = this;
        me.mwConfirm('确定创建新表单？').then(() => {
          me.formData = {};
          me.mwApi.app.changeModuleForm('',me.key, me.moduleId, me.appId).then((res) => {
            me.key=res.result.id;
            me.selKey=me.key;
            me.loadForm();
          });
        }).catch(() => {
        });
      },

      relateOtherForm(){
        let me = this;
        PF.show('treeTable', {
          url: this.mwUrl("/api/app/listApplicationTree"), treeDefaultParams: {category: 'form'},
          selectFirst: false, clearBtn: false
          , title: '选择关联次表单', sureName: '确定', changed: function (data) {
            let me = this;
            me.defaultParams = {code: data.code, category: 'form'};
          }, api: 'app.listApplicationItemsByCode',showSelected:true, singleSelect: false,size:'large_small'

        }, function (res) {
          let ids=[];
          if (res && res.length > 0) {
            res.forEach(v=>{
              ids.push(v.id);
            })
          }
          me.mwApi.app.changeModuleRelateForm(ids,me.formId, me.moduleId, me.appId).then((res) => {
          });

        });
      },

      //选择关联表单
      relateSelectForm() {
        let me = this;
        PF.show('treeTable', {
          url: this.mwUrl("/api/app/listApplicationTree"), treeDefaultParams: {category: 'form'},
          selectFirst: false, clearBtn: true
          , title: '选择关联表单', sureName: '确定', changed: function (data) {
            let me = this;
            me.defaultParams = {code: data.code, category: 'form'};
          }, api: 'app.listApplicationItemsByCode', singleSelect: true

        }, function (res) {
          if (res && res.length > 0) {
            if(!me.form.name)
              me.form.name = res[0].name;
            me.relateFormName= res[0].name;
            me.form.id = res[0].id;
          }else{
            me.relateFormName= '';
            me.form.id = '';
          }
        });
      },
      //取消关联
      cancelRalateForm(){
        let me = this;
        PF.confirm('确定要取消表单关联？').then(() => {
          me.mwApi.app.copeForm(me.formId, me.key, me.moduleId, me.appId).then((res) => {
            me.formId = res.result.formId;
            me.key = res.result.key;
            me.selKey = me.key;
            me.isRelation = false;
            me.loadForm();
          });
        })
      },
      //关联表单
      relateForm() {
        let me = this;
        PF.show('treeTable', {
          url: this.mwUrl("/api/app/listApplicationTree"), treeDefaultParams: {category: 'form'},
          selectFirst: false, clearBtn: false, buttonsScript: `me.footerButton.push({label:'关联并复制', func:function(){
            var data = me.mwRef('dataTable').getMultipleSelection();
            if(data){
              data.$copeForm=true;
              me.params.func(data);
              me.selectCancel();
            }
          }})`
          , title: '选择关联表单', sureName: '关联', changed: function (data) {
            let me = this;
            me.defaultParams = {appId: data.id, category: 'form'};
          }, api: 'app.listComponentsByTypeAndAppId', singleSelect: true

        }, function (res) {
          if (res && res.length > 0) {
            me.formId = res[0].id;
            if (res.$copeForm) {
              me.mwApi.app.copeForm(me.formId,me.key, me.moduleId, me.appId).then((res) => {
                me.formId = res.result.formId;
                me.key=res.result.key;
                me.selKey=me.key;
                me.loadForm();
              });
            } else {
              me.mwApi.app.changeModuleForm(me.formId,me.key, me.moduleId, me.appId).then((res) => {
                me.key=res.result.id;
                me.selKey=me.key;
                me.loadForm();
              });
            }
          }
        });
      },

      loadForm(versionId) {
        let me = this;

        PF.ajax("api/app/getModuleFormConfig",{versionId:versionId,key:me.key},me.moduleId,me.appId).then((data) => {
          me.formLayOut(data.result);
        });
        /*
        me.mwApi.app.getModuleFormConfig(me.moduleId,versionId, me.appId).then((res) => {
          me.formLayOut(res.result);
        })*/
      },

      formLayOut(data) {
        let me = this, win = $(window), offHeight = 60, content = data.content;
        let mwForm = $(me.$el.querySelector('.mw-form_id'));
        mwForm.height(win.height() - offHeight);
        mwForm.width(win.width());
        mwForm.empty();
        me.curStatus=data.status;
        me.curVersion=data.version;
        me.versionNumber= data['#versionNumber'] || 1;
        me.selStatus=data.status;
        me.selVersion=data.version;
        if(data.attr && data.attr.isRelation){
          me.isRelation = true;
        }
        me.key=data.key;
        me.selVersionId = data.formId;
        me.formId = data.formId;

        let con;
        con = content[me.formId];
        if (!con) {
          con = {customId: me.formId, name: (data.formName ? data.formName : data.moduleName)};
        } else {
          if (!con.customId)
            con.customId = me.formId;
        }

        me.formData = con;
        let formValue = me.mwLodash.assign({}, _.pickBy(me.initInfo,(v,k)=>_.startsWith(k,"init")));

        $WR.ready(function (manager) {
          function fnDataItemResolver(dict, params, setDataItems) {
            if ($.isFunction(params) && !setDataItems) {
              setDataItems=params;
              params={};
            }
            me.mwApi.data.getDict(dict,params).then(function (data) {
              if (data.result && data.result.value) {
                let v = data.result.value.split(',');
                let v1 = [];
                let items = []
                v.forEach(function (d) {
                  v1 = d.split('|');
                  items.push({text: v1[1] || v1[0], value: v1[0]});
                });
                setDataItems(items);
              }
            });
          }



          // 弹出对话框回调方法
          function fnDialogResolver(type, ops) {

            if ('dictionary-selector' === type) {
              PF.show('treeTable', {
                url: me.mwUrl("/api/app/listApplicationTree"), size: 'small_large',treeDefaultParams: {category: 'application'},
                selectFirst: false, clearBtn: false, title: '选择字典',clearBtn: true, changed: function (data) {
                  let me = this;
                  me.defaultParams = {
                    applicationId: data.id,
                  };
                }, api: 'data.listDictByApp', singleSelect: true
              }, function (res) {
                if (res && res.length > 0) {
                  ops.setValue(res[0].id, res[0].name,res[0].applicationId);
                }else{
                  ops.setValue("","","");
                }
              });
            }

            if('action-selector'===type){
              let val=ops.getValue();
              if(val && val[0]){
                val=val[0];
              }else{
                val=''
              }

              PF.show('treeTable', {
                url: me.mwUrl("/api/app/listActionComponentByTypeTree"),treeDefaultParams: {type: "系统分类/表单",flag:0}
                ,size: 'small_large',
                selectFirst: true,asyncLoadOnce:true, clearBtn: true, title: '选择动作脚本', changed: function (data) {
                  let me = this;
                  me.defaultParams = {type: data.code, flag:0};
                }, api: 'app.getAllButton', singleSelect: true
              }, function (res) {
                if (res && res.length > 0) {
                  ops.setValue(res[0].action, res[0].name);
                }else{
                  //点了清除按钮
                  ops.setValue("","");
                }
              });
            }
            if ('view-selector' === type) {
              PF.show('treeTable', {
                title: "选择视图",
                url: me.mwUrl("/api/app/listApplicationTree"), treeDefaultParams: {category: 'view'},
                selectFirst: false,
                clearBtn: false,
                changed: function (data) {
                  let me = this;
                  me.defaultParams = {
                    applicationId: data.id,
                    category: 'view',
                    simpleResult:true
                  };
                }, api: 'app.getAppModuleItems', singleSelect: true
              }, function (data) {
                if (data && data.length > 0) {
                  ops.setValue(data[0].id, data[0].name);
                }
              });
            }

            // 关联文件:选择关联模块
            if ('module-selector' === type) {
              PF.show('treeTable',
                {
                  url: me.mwUrl("/api/app/listApplicationTree"),
                  title: '选择关联模块',
                  treeDefaultParams: {category: 'module_flow,module_normal'},
                  selectFirst: false, clearBtn: false,
                  changed: function (data) {
                    let me = this;
                    me.defaultParams = {
                      applicationId: data.id,
                      category: 'module_flow,module_normal',
                      simpleResult:true
                    };
                  },
                  api: 'app.getAppModuleItems'
                }, function (data) {
                  if (data && data.length > 0) {
                    let ids = [];
                    let names = [];
                    data.forEach(d => {
                      ids.push(d.id);
                      names.push(d.name);
                    });
                    ops.setValue(ids.join(), names.join());
                  }
                });
            }

            if ('formula-generator' === type) {
              let data=ops.getValue();
              let defData=me.$newForm.getDefinitionData();

              let fieldXTypes={
                Text:1,
                Textarea:1,
                Select:1,
                CheckboxGroup:1,
                RadioGroup:1,
                Number:1,
                DateTime:1,
                Currency:1,
                Email:1,
                Phone:1,
                Mobile:1,
                PhoneOrMobile:1,
                Hidden:1
              };
              let fields = [{
                name: "编辑状态",
                value: "$fo.textMode",
                operators: 0b1100,
                dataType:"boolean",
                selectable: [{
                  name: "是",
                  value: "true"
                },
                {
                  name: "否",
                  value: "false"
                }]
              }];
              PF.walkTree([defData],"items", function (item) {
                if(fieldXTypes[item.xtype]) fields.push({value:"$f."+item.name,name:item.label || item.name});
              });
              data=data || {};
              data.extraFields=fields;
              PF.formulaGenerator(data,function(data){
                ops.setValue(data);
              });
            }
          }

          function fnImbeddedObjResolver(objId) {
            return new (function (formField) {
              var value = [];
              var component;
              var $data;var $obj;
              PF.apply(this, {
                init: function (d,obj) {
                  $data = d;$obj=obj;
                },
                onChange: function (name, val, d) {
                  $data = d;
                  /*switch (objId) {

                  }*/
                  if (component && component.onChange) {
                    component.onChange(name, val, d);
                  }
                },
                mount: function (fnMount) {
                  var html;
                  let config = Object.assign({
                    expUser: me.expUser,
                    getForm:function(){
                      return me.$newForm._tw;
                    },getCurrentObject:function(){
                      return $obj
                    },
                    getFormObject: function () {
                      return me;
                    },
                    $previewMode: true,
                    getFormValue: function () {
                      return {}
                    },
                    getConfig: function () {
                      return $data;
                    },
                    getData: function () {
                      return {businessId: $uuid(), formId: $uuid(), tempBusinessId: $uuid()}
                    }
                  });
                  switch (objId) {
                    case 'attachment-list': {
                      component = new (Vue.component('form-attachment-list'))({params: me._data, config: config});
                      fnMount(component.$mount().$el);
                      break;
                    }
                    case 'attachment-list-min': {
                      component = new (Vue.component('form-attachment-list-min'))({params: me._data, config: config});
                      fnMount(component.$mount().$el);
                      break;
                    }
                    case 'document-editor': {
                      component = new (Vue.component('form-document-editor'))({params: me._data, config: config});
                      fnMount(component.$mount().$el);
                      break;
                    }
                    case 'comment-list': {
                      component = new (Vue.component('form-comment-list'))({params: me._data, config: config});
                      fnMount(component.$mount().$el);
                      break;
                    }
                    case 'comment-list-min': {
                      component = new (Vue.component('form-comment-list-min'))({params: me._data, config: config});
                      fnMount(component.$mount().$el);
                      break;
                    }
                    case 'imbedded-view': {
                      component = new (Vue.component('form-imbedded-view'))({params: me._data, config: config});
                      fnMount(component.$mount().$el);
                      break;
                    }
                    case 'rel-file-selection': {
                      component = new (Vue.component('form-rel-file-selection'))({params: me._data, config: config});
                      fnMount(component.$mount().$el);
                      break;
                    }
                    default:{
                      if($data.pageType==="page"){
                        let component=PF.createVue({
                          template:"<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
                          data:{
                            pageId:objId,
                            params:{data:me._data,config:config}
                          }
                        });
                        fnMount(component.$mount().$el);
                      }else if($data.pageType==="pageData" && $obj.getPageData){
                        let pageData=$obj.getPageData();
                        pageData.params={data:me._data,config:config};
                        component=PF.createVue(pageData);
                        fnMount(component.$mount().$el);
                      }
                    }
                  }
                  if (html) {
                    fnMount($('<div>' + html + '</div>'));
                  }
                  return component
                },
                onEvent: function (args) {
                  if (component) {
                    if (component.dealWithEvent) {
                      component.dealWithEvent(args);
                    }
                  } else {
                    if (args.dd.viewId && args.data.id) {
                      me.mwApi.app.getApplicationItems([args.dd.viewId], "").then((res) => {
                        let mixId = res.result[0].content.table.moduleId;
                        if (mixId) {
                          let me = this;
                          let p = {};
                          p.businessId = args.data.id;
                          p.moduleId = mixId;
                          p.size = 'large_large'
                          p.type = 'normal'
                          p.editMode = true;
                          p.appId = '';
                          PF.show('normalForm', p, function () {
                          });
                        }
                      })
                      //viewId
                    }
                  }
                },
                setValue: function (value) {
                  //console.log(value);
                },
                getValue: function () {
                  //return value;
                },
                setReadOnly: function () {
                },
                destroy: function () {
                  if (component) {
                    component.$destroy();
                    $(component.$el).remove()
                  }
                },
                show: function (ops) {
                  let config = Object.assign({
                    getForm:function(){
                      return me.$newForm;
                    },getCurrentObject:function(){
                      return $obj
                    },
                    $previewMode: true,
                    getFormValue: function () {
                      return {}
                    }, getConfig: function () {
                      return $data;
                    }, getData: function () {
                      return {businessId: $uuid(), formId: $uuid(), tempBusinessId: $uuid()}
                    }
                  });

                  switch (objId) {
                    case 'department-selection': {

                      var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                      PF.show('orgSelect', {
                        multiple: multiple,
                        config: config,
                        value: ops.getValue()
                      }, function (data) {
                        ops.setValue(data);
                      });
                      break;
                    }
                    case 'user-selection': {
                      var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                      PF.show('orgSelect', {
                        multiple: multiple,
                        config: config,
                        value: ops.getValue()
                      }, function (data) {
                        ops.setValue(data);
                      });
                      break;
                    }
                    case 'department-user-selection': {

                      var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                      PF.show('orgSelect', {
                        multiple: multiple,
                        config: config,
                        value: ops.getValue()
                      }, function (data) {
                        ops.setValue(data);
                      });
                      break;
                    }
                    case 'custom-selection': {
                      //let multi = $data.multiSelection == undefined ? false : $data.multiSelection;
                      let multi=!$data.singleSel;
                      PF.show('viewSelect', {
                        id: $data.viewId,
                        multi: multi,
                        config: config
                      }, function (data) {
                        if (data) {
                          ops.setValue(data);
                        } else {
                          ops.setValue();
                        }
                      });
                      break;
                    }
                    default: {
                      if($data.pageType=="page"){
                        config.setExtraFormField = function(d) {
                          me.extraFormField = d;
                        }
                        config.$obj = $obj;
                        config.ops = ops;
                        var params = {config:config,modelId:me.moduleId};
                        PF.dialog("mw-inner-page",{title:$data.pageTitle,width:$data.pageWidth,height:$data.pageHeight,
                          propsData:{pageId:objId,params:params}})
                      }
                    }
                  }

                },
                hide: function (ops) {
                  ops.setValue(value);
                }
              });
            })(this);
          }

          function fnDataResolver(args) {
            if ('org-sel-default-value' === args.dataId) {
              me.mwApi.org.getCurrent(args.params).then(v => {
                args.fnSetData(v);
              })
            }
          }

          function fnRepositoryResolver(setRepositories)
          {
            me.mwApi.app.getComponentRepositoryConfig().then(v=>{
              //let repositories=v.result.repositories;
              //if(repositories.length==0){
              let  repositories=v.result.repositories;
              //}
              let usedRepositories=v.result.usedRepositories;
              if(!usedRepositories || usedRepositories.length===0){
                usedRepositories=[{id: 'REP-INTERNAL-COMMON'},{id: 'REP-INTERNAL-OA'}];
              }
              setRepositories({
                repositories: repositories,
                usedRepositories:usedRepositories
              });
            })
          }
          manager.create({
            xtype: 'DesignerForm',
            $dd: JSON.parse(JSON.stringify(con)),
            values: formValue,
            layout: 2,
            user: me.expUser,
            resolvers: {
              fnDataResolver: fnDataResolver,
              fnDataItemResolver: fnDataItemResolver,
              fnImbeddedObjResolver: fnImbeddedObjResolver,
              fnDialogResolver: fnDialogResolver,
              fnRepositoryResolver: fnRepositoryResolver
            }
          }, function (x) {
            me.$newForm = x;
            let expContext=Object.assign({
              "$userName":PF.userInfo.name,
              "$loginId":PF.userInfo.loginId,
              "$roleNames":PF.userInfo.roleNames,
              "$deptIdChain":PF.userInfo.deptIdChain,
              '$allIdentityRoleNames':PF.userInfo.allIdentityRoleNames,
              "$ext":formExpContext
            },formExpContext)
            x.setExpressionContext(expContext);
            x.on('afterRender', function () {
              let div=$(`<div style="border-bottom:1px solid #e7eaec;text-align: right;float: left;margin-left: 70px;">
                          <div class="x-fd-toolbar"><div class="btn-group">
                            <button class="btn btn-default btn-sm x-fd-cmd-design active" type="button"><i class="fa fa-newspaper-o fa-fw"></i>设计</button>
                            <button class="btn btn-default btn-sm x-fd-cmd-js" type="button"><i class="fa fa-terminal fa-fw"></i>脚本</button>
                          </div></div>
                        </div>
                        <div style="border-bottom:1px solid #e7eaec;text-align: right;">
                          <div class="x-fd-toolbar">
                                  <button class="btn btn-primary btn-sm x-fd-cmd-relateForm" type="button">关联表单</button>
                                  <button class="btn btn-primary btn-sm x-fd-cmd-cancel-relation" type="button" style="display:none;">取消关联</button>
                                  <button class="btn btn-primary btn-sm x-fd-cmd-versionManage" type="button">版本管理</button>
                                  <button class="btn btn-primary btn-sm x-fd-cmd-revision" type="button">修改记录</button>
                                  <button class="btn btn-primary btn-sm x-fd-cmd-myPreview" type="button"><i class="fa fa-eye fa-fw"></i>预览</button>
                                  <button class="btn btn-primary btn-sm x-fd-cmd-save" type="button"><i class="fa fa-save fa-fw"></i>保存</button>
                                  <!--<button class="btn btn-primary btn-sm x-fd-cmd-save-enable" type="button"><i class="fa fa-save fa-fw"></i>保存并启用</button>-->
                              </div>
                    </div>`);
              if(me.isRelation){
                $('.x-fd-cmd-cancel-relation',div).show();
              }
              if(me.formId)
              $('.x-fd-cmd-save',div).parent().prepend("<span>ID:"+me.formId+"&nbsp;&nbsp;</span>");
              me.$newForm.getToolbarPanelEl().append(div);
              // div.delegate(".btn",'mousedown', function (e) {国产化不支持
              div.find(".btn").on("click", function (e) {
                let text=$(e.target).text();
                switch (text) {
                  case "新建表单":
                    me.createNewForm();
                    break;
                  case "表单管理":
                    me.createNewForm();
                    break;
                  case "关联表单":
                    me.relateForm();
                    break;
                  case "取消关联":
                    me.cancelRalateForm();
                    break;
                  case "版本管理":
                    me.versionManage();
                    break;
                  case "修改记录":
                    me.revisionLog();
                    break;
                  case "保存":
                    me.save(me.curStatus=='0');
                    break;
                  case "预览":
                    me.preview();
                    break;
                  default:
                    //throw new Error("没有处理函数的按钮:"+text)
                }
                /*if(text=='新建表单'){
                  me.createNewForm();
                }

                if(e.currentTarget.innerText=='表单管理'){
                  me.formManage();
                }

                if(e.currentTarget.innerText=='关联表单'){
                  me.relateForm();
                }
                if(e.currentTarget.innerText=='版本管理'){
                  me.versionManage();
                }

                if(e.currentTarget.innerText=='保存'){
                  me.save(me.curStatus=='0');
                }*/

              });
              me.showButton = true;
              setTimeout(function () {
                x.resize(win.width(), win.height() - offHeight);
              }, 500);
              me.isDirty=false;
            });
            win.resize(function () {
              mwForm.height(win.height() - offHeight);
              mwForm.width(win.width());
              x.resize(win.width(), win.height() - offHeight);
            });
            x.on('change', function (a, b) {
              me.isDirty=true;
            });
            x.on('repositoryChange', function(usedRepositories)
            {
              me.mwApi.app.saveComponentRepositoryConfig({
                usedRepositories: usedRepositories
              }).then((res) => {
                  me.mwMsg('组件库设置成功！');
              });
            });
            x.render(mwForm);
            x.on('save', function (data) {

            });
          });
        });
      },

      formDataEqual() {
        let data = PF.decode(PF.encode(this.$newForm.getDefinitionData()))
        return PF.Object.equals(data, this.formData)
      },

      //保存值
      saveValues() {
        let me = this, data = me.$newForm.getDefinitionData();
        me.mwApi.app.setApplicationItemProperties({
          name: data.title,
          content: data,
          customId: data.customId
        }, me.formId, me.appId).then((res) => {
          let params = {
            moduleId: me.moduleId,
            appId: me.appId
          }
          me.$store.dispatch('getFormConfig', params)
        });
      },

      //添加新版本
      addNewVersion() {
        let me = this;
        if(me.versionList.length==0){
          me.mwRef('versionDialog').hide();
          return
        }
        this.mwApi.app.createModuleForm(me.moduleId,me.selVersionId,me.appId).then((data) => {
          me.loadForm(data.result.id);
          me.mwRef('versionDialog').hide();
        });
      },

      //标记删除表单版本
      deleteVersion() {
        let me = this;
        if(me.versionList.length==0){
          me.mwRef('versionDialog').hide();
          return
        }
        if (me.selStatus == '1') {
          me.mwMsg('warning', '启用版本无法删除');
          return;
        }
        if (me.selStatus == '2') {
          me.mwMsg('warning', '历史版本无法删除');
          return;
        }
        if (me.versionList.length == 1) {
          me.mwMsg('warning', '无法删除,至少保留一个版本');
          return;
        }
        me.mwConfirm('确定要删除此表单版本？').then(() => {
          this.mwApi.app.removeDefinition(me.selVersionId,me.appId).then((data) => {
            this.mwApi.app.listExclusiveMarkDeletedDefinition(me.key,me.appId).then((data) => {
              me.versionList = data.result;
              me.mwMsg('删除成功');
              let version = me.versionList[0].version;
              let status = me.versionList[0].status;
              let id = me.versionList[0].id;
              if (me.curVersion == me.selVersion) {
                me.curVersionId = id;
                me.curVersion = version;
                me.curStatus = status;
                me.loadForm(id);
              }
              me.selVersionId = id;
              me.selVersion = version;
              me.selStatus = status;
            });
          });
        }).catch(() => {});
      },

      //编辑表单版本
      editVersion() {
        let me = this;
        if(me.versionList.length==0){
          me.mwRef('versionDialog').hide();
          return
        }else{
          me.mwRef('versionDialog').hide();
          me.loadForm(me.selVersionId);
        }
      },

      //选中表单版本
      selectVersion(version, status,id) {
        let me = this;
        me.selVersionId=id;
        me.selVersion = version;
        me.selStatus = status;
      },

      //启用表单版本
      enableVersion() {
        var me = this;
        if(me.versionList.length==0){
          me.mwRef('versionDialog').hide();
          return
        }
        me.mwConfirm('确定启用此表单版本？').then(() => {
          this.mwApi.app.publishDefinition(me.selVersionId,me.appId).then((data) => {
            this.mwApi.app.listExclusiveMarkDeletedDefinition(me.key,me.appId).then((data) => {
              me.versionList = data.result;
            });

            if(me.selVersion==me.curVersion){
              me.loadForm(me.selVersionId);
              me.mwRef('versionDialog').hide()
            }
            me.mwMsg('启用成功');
          });
        }).catch(() => {

        });
      },

      //表单管理列表
      versionManage() {
        let me = this;
        this.mwApi.app.listExclusiveMarkDeletedDefinition(me.key,me.appId).then((data) => {
          me.versionList = data.result;
          me.mwRef('versionDialog').show();
          me.mwRef('recycleBinDialog').hide();
        });
      },
      revisionLog() {
        let me=this;
        me.$refs.revisionDialog.show();
        if(me.$refs.revisionComp)me.$refs.revisionComp.loadData();
      },
      //回收站
      recycleBinManager(){
        let me = this;
        this.mwApi.app.listMarkDeletedDefinition(me.key,me.appId).then((data) => {
          me.versionDelList = data.result;
          me.mwRef('versionDialog').hide();
          me.mwRef('recycleBinDialog').show();
        });
      },
      //选中标记删除的表单版本
      selectDelVersion(version, status,id) {
        let me = this;
        me.selDelVersionId=id;
        me.selDelVersion = version;
        me.selDelStatus = status;
      },
      //彻底删除
      cascadeDeleteVersion() {
        let me = this;
        if(me.selDelVersion==0){
          me.mwMsg('warning', '请选择一个表单版本');
          return;
        }
        me.mwConfirm('删除后无法恢复，确定要彻底删除表单版本('+me.selDelVersion+'.0)？').then(() => {
          this.mwApi.app.deleteDefinition(me.selDelVersionId,me.appId).then((data) => {
            this.mwApi.app.listMarkDeletedDefinition(me.key,me.appId).then((data) => {
              me.versionDelList = data.result;
              me.mwMsg('删除成功');
              if(me.versionDelList && me.versionDelList.length> 0){
                let version = me.versionDelList[0].version;
                let status = me.versionDelList[0].status;
                me.selDelVersionId = me.versionDelList[0].id;
                me.selDelVersion = version;
                me.selDelStatus = status;
              }else{
                me.selDelVersion = 0;
              }
            });
          });
        }).catch(() => {});
      },
      //恢复
      recoverVersion(){
        let me = this;
        if(me.selDelVersion==0){
          me.mwMsg('warning', '请选择一个表单版本');
          return;
        }
        me.mwConfirm('确定要恢复表单版本('+me.selDelVersion+'.0)？').then(() => {
          this.mwApi.app.recoverDefinition(me.selDelVersionId,me.appId).then((data) => {
            this.mwApi.app.listMarkDeletedDefinition(me.key,me.appId).then((data) => {
              me.versionDelList = data.result;
              me.mwMsg('恢复成功');
              if(me.versionDelList && me.versionDelList.length> 0){
                let version = me.versionDelList[0].version;
                let status = me.versionDelList[0].status;
                me.selDelVersionId=me.versionDelList[0].id;
                me.selDelVersion = version;
                me.selDelStatus = status;
              }else{
                me.selDelVersion = 0;
              }
            });
          });
        }).catch(() => {});
      },
      //返回版本管理
      returnVersionManager(){
        let me = this;

        me.versionManage();
      },
      beforeLeave (next) {
        //外面点切换前自己特殊执行的函数
        if (this.isDirty) {
          //已经修改过没保存
          PF.confirm("表单尚未保存，是否离开？")
            .then(o=>{
              next();
            })
            .catch(o=>{
              next(false);
            });
        }else{
          next();
        }
      },
      formRevert() {
        this.loadForm();
      }
    },
    beforeDestroy() {
      try {
        this.$newForm.destroy();
      } catch (e) {
      }
    }
  };


</script>



// WEBPACK FOOTER //
// src/modules/index/views/formEdit/common/Form.vue